import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import { AudioProvider } from "./audio/AudioProvider.js";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AudioProvider>
      <App />
    </AudioProvider>
  </React.StrictMode>,
);
